import { http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';

export class ActivityService {
   async getActivities(customerId: number, query: LocationQuery) {
      const response = await http.get(`/customers/${customerId}/activities`, { params: query });
      return response.data;
   }

   async getActivity() {
      throw Error('Method not implemented');
   }

   async postActivity() {
      throw Error('Method not implemented');
   }

   async putActivity() {
      throw Error('Method not implemented');
   }

   async deleteActivity() {
      throw Error('Method not implemented');
   }
}
